import { Input, Modal, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import useStatsStore from 'modules/engagement_report/engagement_stats/store';
import { useTicketGroups } from 'pages/store';
import { Button } from 'react-bootstrap';
import { PlusOutlined } from '@ant-design/icons';
const CreateGroup = () => {
    const { users, fetchUserData } = useStatsStore();
    const { createTicketingGroup } = useTicketGroups();

    const [groupName, setGroupName] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [userData, setUserData] = useState([]);
    useEffect(() => {
        fetchUserData();
    }, [])

    const [sortedUserData, setSortedUserData] = useState([])
    const [userOptions, setUserOptions] = useState([])
    useEffect(() => {
        const options = [];
        const sortedData = users.map((user) => {
            options.push({
                value: user.user.first_name + '|' + user.user_id+ '|' + user.user.email,
                label: `${user.user.first_name} (${user.user.email})`,
            })
            return {
                user_id: user.user_id,
                first_name: user.user.first_name,
                email: user.user.email,
                is_active: true
            }
        })
        const usersDataById = _.groupBy(sortedData, 'user_id');
        setSortedUserData(usersDataById);
        setUserOptions(options)
    }, [users])


    const handleOk = () => {
        createTicketingGroup({
            groupId: groupName,
            users: userData,
            action: 'CREATED'
        })
        setModalOpen(false);
    };

    const handleCancel = () => {
        setGroupName('');
        setModalOpen(false);
    };


    const handleSelect = (value) => {
        const data = value.map((userId) => {
            return sortedUserData[userId.split('|')[1]][0]
        })
        setUserData(data);
    }

    return (
        <div>
            <Button className='p-2' type="primary" onClick={() => setModalOpen(true)}>
                <PlusOutlined /> Create New Group
            </Button>
            <Modal
                destroyOnClose
                title={groupName.length ? groupName : 'Group Name'}
                centered
                width={1000}
                open={modalOpen}
                onOk={handleOk}
                okText='Submit'
                okButtonProps={{ disabled: groupName.length < 4 || _.size(userData) === 0 }}
                onCancel={handleCancel}
                closeIcon={false}
            >
                <div className='d-flex justify-content-between align-items-center gap-4'>

                    <Space style={{ flex: 1 }} direction="vertical">
                        <Input preserve={false} addonBefore="Group Name" allowClear onChange={(event) => setGroupName(event.target.value)} />
                    </Space>

                    <Select
                        mode="multiple"
                        style={{ flex: 1 }}
                        placeholder="Please select"
                        onChange={handleSelect}
                        options={userOptions}
                        allowClear
                        virtual={false}
                    />
                </div>
            </Modal>
        </div>
    )
}

export default CreateGroup